define('uikit/collections/container',['require','exports','module','marionette','underscore','../mixins/component.mixin','../channel'],function(require, exports, module){
  var Mn = require('marionette');
  var _ = require('underscore');
  var ComponentMixin = require('../mixins/component.mixin');
  var channel = require('../channel');

  var ContainerView = Mn.ItemView.extend(ComponentMixin).extend({

    template: function() { return ''; },

    childViewEventPrefix: 'childview',

    childOptions: {
      destroyOnRemove : false,
      at              : null
    },

    destroyChildren: true,  // not destroying children on destory can easily be a source of leaks
                            // we should force anything that uses this component
                            // to actively opt in to this

    initialize: function() {
      ComponentMixin.initialize.apply(this, arguments);

      this._views = [];

      this.once('render', function() {
        this.listenTo(this, 'add remove', this._requestRender);
      }, this);

      this.listenTo(this, 'before:render', this._onBeforeRenderCCV);

      this.listenTo(this, 'render', this._onRenderCCV);

      this.listenTo(this, 'add', this._onChildViewAddCCV);

      this.listenTo(this, 'remove', this._onChildViewRemoveCCV);

      this.listenTo(this, 'destroy', this._onDestroyCCV);
    },

    normalizeMethods: Mn.normalizeMethods,

    proxyChildEvents: Mn.CollectionView.prototype.proxyChildEvents,

    _ensureRendered: function(view) {
      if (!view.isRendered) {
        view.render();
      }
    },

    _triggerMethodOnChild: function(event, childView) {
      Mn.triggerMethodOn(childView, event);
    },

    _onBeforeRenderCCV: function() {
      // Before rendering we want to detach all of our internal views
      // elements.  By detaching them we preserve their event
      // bindings.  Re-rendering the template with jquery would
      // otherwise kick off all the view elements from the dom
      // and also wipe their events (that's what jquery does
      // for some reason)
      if (this.isRendered) {
        _.each(this._views, function(item) {
          item.view.$el.detach();
        }, this);
      }
    },

    _onRenderCCV: function() {
      var _views = this._views.slice(0);

      // sometimes calling render will remove items from the _views array
      // do this separately from appending the view;
      for (var i = 0, len = _views.length, item; i < len; i++) {
        item = _views[i];
        this._ensureRendered(item.view);
      }
      for (var i = 0, len = this._views.length, item; i < len; i++) {
        item = this._views[i];
        if (item.triggerShow) {
          Mn.triggerMethodOn(item.view, 'before:show');
        }
        this.appendView(item.view, item.options);
        if (item.triggerShow) {
          Mn.triggerMethodOn(item.view, 'show');
        }
        item.triggerShow = false;
      }

      this.triggerMethod('after:render:all');
    },

    appendView: function(view, options) {
     this.$el.append(view.$el);
     return this;
    },

    _onChildViewAddCCV: function(view, options) {
      this.proxyChildEvents(view);
    },

    _onChildViewRemoveCCV: function(view, options) {
      if (options.destroyOnRemove === true || options.destroy === true) {
        view.destroy();
      }
    },

    _onDestroyCCV: function() {
      if (this.getOption('destroyChildren')) {
        this.each(function(view) {
          view.destroy();
        });
      }
    },

    add: function(view, options) {
      options = _.extend({}, this.getOption('childOptions'), options);
      this.triggerMethod('before:add', view, options);

      var item = {
        view        : view,
        triggerShow : this._isShown,
        options     : options
      };

      if (options.at != null) {
        this._views.splice(options.at, 0, item);
      } else {
        this._views.push(item);
      }

      this.listenTo(view, 'destroy', function() {
        this.removeView(view);
      })

      view.options.parent = this;
      view._parent = this;

      this.triggerMethod('add', view, options);

      return this;
    },

    bindToVisibility: function() {
      _.each(this._views, function(item, index) {
        if (item.__cachedFunction) {
          this.stopListening(item.view, 'change:visible', item.__cachedFunction);
        }

        item.__cachedFunction = function(view, value, previous) {
          if (value && previous === false) {
            this.add(item.view, { at: index });
          } else if (!value) {
            this.removeView(item.view);
            this.listenTo(item.view, 'change:visible', item.__cachedFunction);
          }
        };

        this.listenTo(item.view, 'change:visible', item.__cachedFunction);
      }, this);

      return this;
    },

    addAll: function(items, options) {
      _.each(items, function(view) {
        this.add(view, options);
      }, this)
      return this;
    },

    removeAll: function(items, options) {
      if (!_.isArray(items)) {
        options = items;
        items = null;
      }
      options = options || {};
      _.each(items || this.toArray(), function(view) {
        this.removeView(view, options);
      }, this)
      return this;
    },

    empty: function() {
      var views =  _.pluck(this._views, 'view');
      this.removeAll(views);
      return views;
    },

    removeView: function(view, options) {
      var index = -1;
      for (var i = 0, len = this._views.length, item; i < len; i++) {
        item = this._views[i];
        if (item.view === view) {
          index = i;
          options = _.extend({}, item.options, options);
          break;
        }
      }
      if (index > -1) {
        this.triggerMethod('before:remove:child', view, options);
        this.stopListening(view);
        this._views.splice(index, 1);
        this.triggerMethod('remove', view, options);
        if (view.options.parent === this) {
          view.options.parent = null;
        }
        if (view._parent === this) {
          view._parent = null;
        }
      }
      return this;
    },

    onBeforeRemove: function(view) {
      view.$el.parent().detach();
    },

    each: function(fn, context) {
      return _.each(_.pluck(this._views, 'view'), fn, context || this);
    },

    at: function(index) {
      var item = this._views[index];
      if (item) {
        return item.view;
      }
    },

    last: function() {
      var last = _.last(this._views);
      if (last) {
        return last.view;
      }
    },

    has: function(view) {
      return !!_.find(this._views, function(o) {
        return o.view === view;
      });
    },

    toArray: function() {
      return _.pluck(this._views, 'view');
    },

    isEmpty: function() {
      return this._views.length === 0;
    },

    count: function() {
      return this._views.length;
    },

    indexOf: function(view) {
      var index = -1;
      for (var i = 0, len = this._views.length, item; i < len; i++) {
        item = this._views[i];
        if (item.view === view) {
          index = i;
          break;
        }
      }
      return index;
    },

    findByName: function(name) {
      var item = _.find(this._views, function(item) {
        if (item.view.getOption('name') === name) {
          return true;
        }
      });
      if (item) {
        return item.view;
      } else {
        return null;
      }
    }

  });

  channel.reply('container', function() {
    return ContainerView;
  })

  module.exports = ContainerView;
});
